/* eslint-disable no-restricted-properties */

// this is the only place we should use window.location. It will break the DMO embed if it is used
// elsewhere. Ideally you should avoid using these at all except for a few cases like auth, try router.push instead.

import { routeChangeEmitter } from "@/lib/embedded/route-change-emitter"
// these can live outside of redux, so need to do this check instead
import { isEmbedded } from "@/lib/is-embedded"

class MtLocation {
  get hash() {
    return window.location.hash
  }

  get search() {
    return window.location.search
  }

  get pathname() {
    return window.location.pathname
  }

  get href() {
    return window.location.href
  }

  get origin() {
    return window.location.origin
  }

  get host() {
    return window.location.host
  }

  get hostname() {
    return window.location.hostname
  }

  setHash(hash: string) {
    window.location.hash = hash
  }

  setHref(href: string) {
    if (isEmbedded()) {
      routeChangeEmitter.emit(href)
      return
    }
    window.location.href = href
  }

  reload() {
    window.location.reload()
  }

  replace(href: string) {
    if (isEmbedded()) {
      routeChangeEmitter.emit(href)
      return
    }
    window.location.replace(href)
  }
}

export const mtLocation = new MtLocation()
